// start:ng42.barrel
export * from './ILogBatch';
export * from './ILogEntry';
export * from './IRecords';
export * from './IValue';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/Logging/index.ts